type BadgeProps = {
  label: string;
  classes: string;
};

export const Badge: React.FC<BadgeProps> = ({ label, classes }) => (
  <span className={`inline-block px-3 py-1 text-sm font-medium ${classes}`}>{label}</span>
);
